import { render, staticRenderFns } from "./SquareFacebook.vue?vue&type=template&id=a276c8c0&"
import script from "./SquareFacebook.vue?vue&type=script&lang=js&"
export * from "./SquareFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports